// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Skip Wins Button

skipWinsButton = {};

skipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    let isAnimating = gameController.stormLinkPayout;

    if (!isAnimating) {
      isAnimating =
        gameController.isAnimatingWins() &&
        this._flags.platformEnabled &&
        !gameController.animWinsFinished &&
        !gameController.winSkipped;
    }

    return isAnimating;
  };

  button.canShow = function () {
    let isAnimating = gameController.stormLinkPayout;

    if (!isAnimating) {
      isAnimating =
        gameController.isAnimatingWins() &&
        this._flags.platformEnabled &&
        !gameController.animWinsFinished &&
        !gameController.winSkipped;
    }

    if (gameController.buyABonusFireball) {
      if (isAnimating) {
        isAnimating = gameController.stormLinkSkip;
      }
    }

    return isAnimating;
  };

  button.onPressedCallback = function () {
    resourceManager.getController("inputOverlord").disableAll();

    if (gameController.buyABonusFireball) {
      resourceManager
        .get("slotContainer:firelinkFeatureContainer:firelinkFeature")
        .skip();

      gameController.stormLinkSkip = false;
    } else {
      gameController.skip();
    }

    if (button.soundName !== "") {
      button.playSound();
    }
  };

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.onConfig = function (config) {
    button._flags.platformEnabled = config.data.uiElements.btnSkip.enabled;
    button._flags.platformVisible = config.data.uiElements.btnSkip.visible;
  };

  messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);

  return button;
};

skipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
skipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "jjSkipWinsButton",
  skipWinsButton.create,
  skipWinsButton.initialise,
  skipWinsButton.getFilesRequired
);
